export const classnames = (obj: object) =>
  Object.entries(obj)
    .filter(([_, condition]) => condition)
    .map(([className]) => className)
    .join(" ");
